import { render, staticRenderFns } from "./StepPageTemplate.vue?vue&type=template&id=0b00ca9b&scoped=true&"
import script from "./StepPageTemplate.vue?vue&type=script&lang=js&"
export * from "./StepPageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./StepPageTemplate.vue?vue&type=style&index=0&id=0b00ca9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b00ca9b",
  null
  
)

export default component.exports